import { useCallback } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { theme } from 'antd';

/**
 * Hands antd's final tokens to styled-components as `theme.token.*`, next to the
 * legacy `theme.colors.*`, so a styled element and an antd component read the same
 * values — including the custom keys in `src/config/antdTheme.js` (`panelGlassBg`).
 *
 * Must render under `ConfigProvider`. `var(--ant-*)` is not an alternative: antd v6
 * scopes its CSS variables to a `.css-var-*` class, not `:root`, so they do not
 * resolve outside antd's own elements.
 */
export const AntdTokenBridge = ({ children }) => {
	const { token } = theme.useToken();

	// A function theme receives the enclosing theme, so `colors` and the rest stay.
	const merge = useCallback(outer => ({ ...outer, token }), [token]);

	return <StyledComponentsThemeProvider theme={merge}>{children}</StyledComponentsThemeProvider>;
};
